module.exports = __webpack_public_path__ + "static/media/popup4-min.e3f93507.png";